import React, { useEffect, useState, useRef, useCallback } from "react";
import { useParams } from "react-router-dom";
import axios from 'axios';
//import { Box, Typography, TextField, Button, Link, Dialog, DialogTitle, DialogContent, DialogActions, Avatar } from '@mui/material';
import { Box, Button, Typography, Link, TextField, Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText, List, ListItem, ListItemAvatar, ListItemText, Avatar } from '@mui/material';
import { useLocation, useHistory } from 'react-router-dom';
import logo from "../components/Logo/Colloquia_Logo.png";
import Tooltip from '@mui/material/Tooltip';

function CaliforniaBillCommentsPage() {
   const { id } = useParams();
   const [calBill, setCalBill] = useState(null);
   const [comments, setComments] = useState([]);
   const [newComment, setNewComment] = useState('');
   const history = useHistory();
   const [open, setOpen] = useState(false);
   const [title, setTitle] = useState('');
   const [content, setContent] = useState('');

   const [openDialog, setOpenDialog] = useState(false);
   const [voteType, setVoteType] = useState(null); // "Pass" | "No Pass"
   const [comment, setComment] = useState("");
   const [activePostId, setActivePostId] = useState(null);

   const [replyOpen, setReplyOpen] = useState(false);
   const [replyText, setReplyText] = useState("");
   const [activeCommentId, setActiveCommentId] = useState(null);

  const [undoDialogOpen, setUndoDialogOpen] = useState(false);
  const [pendingUndoCaseId, setPendingUndoCaseId] = useState(null);
  const [pendingUndoBill, setPendingUndoBill] = useState(null);

  const [openVotersDialog, setOpenVotersDialog] = useState(false);
  const [activeVoters, setActiveVoters] = useState([]);
  const [dialogTitle, setDialogTitle] = useState("");

  const [loggedInUser, setLoggedInUser] = useState(null);
  useEffect(() => {
        axios.get("/user/me")
            .then(res => setLoggedInUser(res.data))
            .catch(() => setLoggedInUser(null));
    }, []);

   // fetch california bill info
   useEffect(() => {
       axios.get(`/calBill/${id}`)
           .then(res => setCalBill(res.data))
           .catch(err => console.error("Error loading case", err));
       }, [id]);

    //console.log(calBill);

    
   // Fetch comments
   /*useEffect(() => {
   axios.get(`/calBill/${id}/comments`)
       .then(res => setComments(res.data))
       .catch(err => console.error("Error loading comments", err));
   }, [id]);*/
    const [cursor, setCursor] = useState(null);
   const [loading, setLoading] = useState(false);
   const [hasMore, setHasMore] = useState(true);
   const fetchComments = async () => {
       if (loading || !hasMore) return;
       try {
           setLoading(true);
           const res = await axios.get(`/calBill/${id}/comments`, {
               params: { cursor, limit: 10 }
           });
           setComments(prev => {
               const existingIds = new Set(prev.map(c => c._id));
               const newComments = res.data.comments.filter(c => !existingIds.has(c._id));
               return [...prev, ...newComments];
           });
           setCursor(res.data.nextCursor);
           setHasMore(res.data.hasMore);
       } catch (err) {
           console.error("Error loading comments", err);
       } finally {
           setLoading(false);
       }
   };
   useEffect(() => {
       setComments([]);
       setCursor(null);
       setHasMore(true);
   }, [id]);
   useEffect(() => {
       fetchComments();
   }, [id]);
   const observer = useRef();
   const lastCommentRef = useCallback(node => {
       if (loading) return;
       if (observer.current) observer.current.disconnect();
       observer.current = new IntersectionObserver(entries => {
           if (entries[0].isIntersecting && hasMore) {
           fetchComments();
           }
       });
       if (node) observer.current.observe(node);
   }, [loading, hasMore]);

   /*const handleSubmitComment = async () => {
       if (!newComment.trim()) return;
       try {
           const res = await axios.post(`/calBill/${id}/comment`, { text: newComment }); // NOTE: single 'comment'
           setComments(prev => [res.data, ...prev]);
           setNewComment('');
       } catch (err) {
           console.error("Error submitting comment", err);
       }
   };*/
    const handleSubmitComment = async () => {
      if (!newComment.trim()) return;

      try {
          const res = await axios.post(`/calBill/${id}/comment`, {
               text: newComment,
           });

          //const commentRes = await axios.get(`/calBill/${id}/comments`);
          //setComments(commentRes.data);
          setComments(prev => [res.data, ...prev]);
          setNewComment('');
      } catch (err) {
          console.error("Error submitting comment", err);
      }
  };

   const toggleVote = async (calBillId) => {
       try {
           const res = await axios.post(`/calBill/${calBillId}/upvote`);
           const { upvotes, voted } = res.data;




           setCalBill(prevCase => ({
               ...prevCase,
               upvoteCount: upvotes,
               voted
           }));
       } catch (err) {
           console.error('Error toggling vote:', err);
       }
   };




   const handleSubmit = async () => {
       try {
           await axios.post('/api/govPosts', {
               title,
               content,
               topic: 'page2subpaged' // this allows you to filter it in Page2SubPageD
           });
           setOpen(false);
           setTitle('');
           setContent('');
           alert('Post created!');
       } catch (err) {
           console.error('Failed to create post', err);
       }
   };



/*
   const togglePass = async (calBillId) => {
       try {
           const res = await axios.post(`/calBill/${calBillId}/pass`);
           const { upvotes, calBillVoted } = res.data;




           calBillCase(prev => ({
               ...prev,
               passCount: upvotes,
               calBillVoted
           }));
       } catch (err) {
           console.error('Error toggling vote:', err);
       }
   };




   const toggleNoPass = async (calBillId) => {
       try {
           const res = await axios.post(`/calBill/${calBillId}/noPass`);
           const { upvotes, calBillVoted } = res.data;




           setCalBill(prev => ({
               ...prev,
               noPassCount: upvotes,
               calBillVoted
           }));
       } catch (err) {
           console.error('Error toggling vote:', err);
       }
   };


   const handleOpenDialog = (calBillId) => {
      setActivePostId(calBillId);
      setOpenDialog(true);
   };




   const handleSubmitVote = async () => {
       if (!voteType || !comment.trim() || !activePostId) {
           alert("Please choose vote type and enter a comment.");
           return;
       }




       try {
           const res = await axios.post(`/calBill/${activePostId}/comment`, { text: comment }); // NOTE: single 'comment'
           setComments(prev => [res.data, ...prev]);




           if (voteType === "Pass") {
               await togglePass(activePostId);
           } else {
               await toggleNoPass(activePostId);
           }
           setOpenDialog(false);
           setComment("");
           setVoteType(null);
       } catch (err) {
           console.error(err);
       }
   };*/
    const isSameUser = (voteUser, loggedInUserId) => {
        if (!voteUser) return false;
        return typeof voteUser === "string"
            ? voteUser === loggedInUserId
            : voteUser._id === loggedInUserId;
    };

  const toggleNoPass = async (billId, commentId) => {
        try {
            const res = await axios.post(`/calBill/${billId}/noPass`, {commentId});
            const { upvotes, billVoted } = res.data;

            setCalBill(prev => {
                if (!prev || prev._id !== billId) return prev;
                    return {
                        ...prev,

                        // update counts
                        noPassCount: upvotes,

                        votedStateBill: true,
                        votedSide: "no pass",
                        /*billVoted,

                        // update voter list 
                        billVoters: [
                            ...(prev.billVoters || []),
                            {
                                _id: loggedInUser._id,
                                username: loggedInUser.username,
                                first_name: loggedInUser.first_name,
                                last_name: loggedInUser.last_name,
                                profileImageUrl: loggedInUser.profileImageUrl,
                                tier: loggedInUser.tier,
                            },
                        ],

                        // record no pass vote
                        noPassPowerVotes: [
                            ...(prev.noPassPowerVotes || []),
                            {
                            user: {
                                _id: loggedInUser._id,
                                username: loggedInUser.username,
                                first_name: loggedInUser.first_name,
                                last_name: loggedInUser.last_name,
                                profileImageUrl: loggedInUser.profileImageUrl,
                                tier: loggedInUser.tier,
                            },
                            comment: commentId,
                            },
                        ],

                        // make sure pass votes does NOT contain user
                        passPowerVotes: (prev.passPowerVotes || []).filter(
                            v => !isSameUser(v.user, loggedInUser._id)
                        ),*/
                    }
                }
            );
        } catch (err) {
            console.error('Error toggling vote:', err);
        }
    };

  const togglePass = async (billId, commentId) => {
        try {
            const res = await axios.post(`/calBill/${billId}/pass`, {commentId});
            const { upvotes, billVoted } = res.data;

            setCalBill(prev => {
                if (!prev || prev._id !== billId) return prev;
                    return {
                        ...prev,

                        // update counts
                        passCount: upvotes,
                        
                        votedStateBill: true,
                        votedSide: "pass",
                        /*billVoted,

                        // update voter list
                        billVoters: [
                            ...(prev.billVoters || []),
                            {
                                _id: loggedInUser._id,
                                username: loggedInUser.username,
                                first_name: loggedInUser.first_name,
                                last_name: loggedInUser.last_name,
                                profileImageUrl: loggedInUser.profileImageUrl,
                                tier: loggedInUser.tier,
                            },
                        ],

                        // record pass vote
                        passPowerVotes: [
                            ...(prev.passPowerVotes || []),
                            {
                            user: {
                                _id: loggedInUser._id,
                                username: loggedInUser.username,
                                first_name: loggedInUser.first_name,
                                last_name: loggedInUser.last_name,
                                profileImageUrl: loggedInUser.profileImageUrl,
                                tier: loggedInUser.tier,
                            },
                            comment: commentId,
                            },
                        ],

                        // remove from no pass votes if present
                        noPassPowerVotes: (prev.noPassPowerVotes || []).filter(
                            v => !isSameUser(v.user, loggedInUser._id)
                        ),*/
                    }
                }
            );
        } catch (err) {
            console.error('Error toggling vote:', err);
        }
    };

  const handleOpenDialog = (billId) => {
        setActivePostId(billId);
        setOpenDialog(true);
    };

  const handleSubmitVote = async () => {
        if (!voteType || !comment.trim() || !activePostId) {
            alert("Please choose vote type and enter a comment.");
            return;
        }

        try {
            const commentRes = await axios.post(
                `/calBill/${activePostId}/comment`,
                { text: comment }
            );

            const commentId = commentRes.data._id; 

            //setComments(prev => [commentRes.data, ...prev]);
            const getCommentRes = await axios.get(`/calBill/${id}/comments`);
            setComments(getCommentRes.data);

            if (voteType === "NP") {
                await toggleNoPass(activePostId, commentId);
            } else {
                await togglePass(activePostId, commentId);
            }
            setOpenDialog(false);
            setComment("");
            setVoteType(null);
        } catch (err) {
            console.error(err);
        }
    };

    /*
    const handleUndoVote = async (billId, bill) => {
	    const res = await axios.post(`/calBill/${billId}/undoVote`);

        const { upvotes, billVoted, deletedCommentId } = res.data;

       if (
            bill.noPassPowerVotes?.some(
                vote => isSameUser(vote.user, loggedInUser._id)
            )
            ) {
                setCalBill(prev => {
                    if (!prev || prev._id !== billId) return prev;
                        return {
                            ...prev,

                            // keep working count logic
                            noPassCount: upvotes,
                            billVoted,

                            // remove user from arrays so button updates
                            billVoters: (prev.billVoters || []).filter(
                                v => !isSameUser(v, loggedInUser._id)
                            ),
                            noPassPowerVotes: (prev.noPassPowerVotes || []).filter(
                                v => !isSameUser(v.user, loggedInUser._id)
                            ),
                        }
                    }
                );
            } else if (
                bill.passPowerVotes?.some(
                    vote => isSameUser(vote.user, loggedInUser._id)
                )
            ) {
                setCalBill(prev => {
                    if (!prev || prev._id !== billId) return prev;
                        return {
                            ...prev,

                            // keep working count logic
                            passCount: upvotes,
                            billVoted,

                            // remove user from arrays so button updates
                            billVoters: (prev.billVoters || []).filter(
                                v => !isSameUser(v, loggedInUser._id)
                            ),
                            passPowerVotes: (prev.passPowerVotes || []).filter(
                                v => !isSameUser(v.user, loggedInUser._id)
                            ),
                        }
                    }
                );
            }
            setComments(prev =>
                prev.filter(comment => comment._id !== deletedCommentId)
            );
    };*/
    const handleUndoVote = async (billId) => {
        try {
            const res = await axios.post(`/calBill/${billId}/undoVote`);
            const { upvotes, deletedCommentId } = res.data;

            setCalBill(prev => {
                if (!prev || prev._id !== billId) return prev;

                const updated = { ...prev };

                // Use votedSide as the single source of truth
                if (prev.votedSide === "no pass") {
                    updated.noPassCount = upvotes;
                } else if (prev.votedSide === "pass") {
                    updated.passCount = upvotes;
                }

                // Reset vote state (THIS fixes your UI instantly)
                updated.votedStateBill = false;
                updated.votedSide = null;

                return updated;
            });

            // Remove associated comment (if backend deleted it)
            if (deletedCommentId) {
                setComments(prev =>
                    prev.filter(comment => comment._id !== deletedCommentId)
                );
            }

        } catch (err) {
            console.error("Error undoing vote:", err);
        }
    };

    /*const openNoPassVoters = (e, bill) => {
        e.stopPropagation();
        setDialogTitle("No Pass Votes");
        setActiveVoters(bill.noPassPowerVotes || []);
        setOpenVotersDialog(true);
    };

    const openPassVoters = (e, bill) => {
        e.stopPropagation();
        setDialogTitle("Pass Votes");
        setActiveVoters(bill.passPowerVotes || []);
        setOpenVotersDialog(true);
    };*/
    /*
    const openNoPassVoters = async (e, bill) => {
        e.stopPropagation();
        setDialogTitle("No Pass Votes");

        try {
            const res = await axios.get(`/stateBill/${bill._id}/voters?side=no pass`);
            setActiveVoters(res.data);
            setOpenVotersDialog(true);
        } catch (err) {
            console.error(err);
        }
    };

    const openPassVoters = async (e, bill) => {
        e.stopPropagation();
        setDialogTitle("Pass Votes");

        try {
            const res = await axios.get(`/stateBill/${bill._id}/voters?side=pass`);
            setActiveVoters(res.data);
            setOpenVotersDialog(true);
        } catch (err) {
            console.error(err);
        }
    };*/


/*
   const toggleCommentVote = async (commentId) => {
       try {
               // hit backend endpoint that toggles a vote
               const res = await axios.post(`/calBillComments/${commentId}/upvote`);

               // update <posts> in react state so ui rerenders
               // setPosts(prev => ...) receives the previous array of posts and must return a new array
               // prev.map( p => { ... } )
               // iterate through every post p in old array
               // if p is the one user just voted on, return a new object with the fresh upvote info from server
               // otherwise, return p unchanged
           setComments((prev) =>
               prev.map((p) =>
                   p._id === commentId
                       ? {
                           ...p, // copy exisiting post fields
                           upvotes: res.data.upvotes, // updated count
                           voted:   res.data.voted // true or false that user voted
                       }
                       : p // all other posts unchanged
               )
           );

       } catch(err) {
           console.error("Vote error", err);
       }
   };
*/
    const toggleCommentVote = async (commentId) => {
        try {
            //const res = await axios.post(`/billComments/${commentId}/upvote`);
            const res = await axios.post(`/calBill/${id}/commentReplies/${commentId}/upvote`);
            const { replyUpvotes, replyVoted } = res.data;

            // Update ONLY the affected comment (O(n), no refetch)
            setComments(prev =>
                prev.map(comment =>
                    comment._id === commentId
                    ? {
                        ...comment,
                        upvotes: replyUpvotes,   // updated count from backend
                        voted: replyVoted      // updated vote state
                        }
                    : comment
                )
            );

        } catch (err) {
            console.error("Vote error", err);
        }
    };


   const handleReplyOpen = (commentId) => {
       setActiveCommentId(commentId);
       setReplyOpen(true);
   };




   const handleReplyClose = () => {
       setReplyOpen(false);
       setReplyText("");
       setActiveCommentId(null);
   };




   const handleReplySubmit = async () => {
       if (!replyText.trim()) return;


       try {
       const res = await axios.post(`/calBill/comments/${activeCommentId}/replies`, {
           text: replyText
       });


       // Update state with new reply
       setComments(prev =>
           prev.map(c =>
           c._id === activeCommentId
               ? { ...c, replies: [...(c.replies || []), res.data] }
               : c
           )
       );


       handleReplyClose();
       } catch (err) {
       console.error("Reply error", err);
       }
   };
   
   const visitProfile = (e, userId) => {
        e.stopPropagation(); // prevent opening the post
        history.push(`/user/view/${userId}`);
    };

   //const scotusRespondentCount = scotusCase.respondentCount || 0;
   const calBillPassCount = calBill?.passCount ?? 0;
   //console.log(scotusRespondentCount);
  
   const callBillNoPassCount = calBill?.noPassCount ?? 0;
   let votePercentage = 0;
   if (calBillPassCount > callBillNoPassCount) {
       votePercentage =calBillPassCount/(calBillPassCount+callBillNoPassCount)
   } else if (callBillNoPassCount > calBillPassCount) {
       votePercentage = callBillNoPassCount/(calBillPassCount+callBillNoPassCount)
   }




   let offset = 0;
   if (calBillPassCount > callBillNoPassCount) {
       offset = votePercentage * 50; // move right
   } else if (callBillNoPassCount > calBillPassCount) {
       offset = -votePercentage * 50; // move left
   }




   let tickColor = "blue"; // default at center
   if (offset > 0) {
       tickColor = "red"; // right side
   } else if (offset < 0) {
       tickColor = "red"; // left side
   }
   
    //const { id } = useParams();
   //return <h1>California Bill Comments for {id}</h1>;

   const navItems = [
        {
            label: "Popular Opinion",
            path: "/Government/popular",
            matchPaths: ["/Government/popular"]
        },
        {
            label: "Following",
            path: "/Government/following",
            matchPaths: ["/Government/following"]
        },
        {
            label: "Supreme Court",
            path: "/Government/SupremeCourt",
            matchPaths: [
            "/Government/SupremeCourt",
            "/scotusCase"
            ]
        },
        {
            label: "Congressional Bills",
            path: "/Government/CongressionalBills",
            matchPaths: [
            "/page2/b",
            "/bill"
            ]
        },
        {
            label: "State Legislature Bills",
            path: "/Government/StateBills",
            matchPaths: [
                "/Government/StateBills",
                "/calBill"
            ]
        },
        {
            label: "Elections",
            path: "/Government/Elections/GubernatorialElections",
            matchPaths: ["/Government/Elections"]
        }
    ];

    const location = useLocation();

    const isActive = (item) => {
        return item.matchPaths.some((match) =>
            location.pathname.startsWith(match)
        );
        };

        const getButtonStyles = (item) => {
        const active = isActive(item);

        return {
            padding: "6px 12px",
            borderColor: active ? "#1f1f1f" : "#333333",
            color: active ? "#1f1f1f" : "#333333",
            backgroundColor: active ? "rgba(0,0,0,0.08)" : "transparent",
            fontWeight: active ? 600 : 500,
            transition: "all 0.15s ease",
            "&:hover": {
            borderColor: "black",
            color: "black",
            backgroundColor: "rgba(0,0,0,0.12)"
            }
        };
    };
   return(
       <div
          style={{
              padding: '20px',
              backgroundColor: '#FFFDF8',
              minHeight: '100vh',  // ensures it covers the full viewport height
              boxSizing: 'border-box', // ensures padding doesn't affect layout
          }}
      >


          <div style={{ width: '200px' }}></div>

          {/*<Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              gap={2}
              flexWrap="wrap"
              sx={{
                  mt: 4,
                  mb: 4,
              }}
                  >
                    <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/a')}
                   >
                       Popular Opinion
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/d')}
                   >
                       Following
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/supremeCourtCases')}
                   >
                       Supreme Court
                   </Button>
                   <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page2/b/b2')}
                    >
                        Congressional Bills
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page2/CaliforniaBills')}
                    >
                        State Legislature Bills
                    </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/c')}
                   >
                       Elections
                   </Button>


           </Box>*/}
            <Box
                sx={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1000,
                    backgroundColor: "#FFFDF8",
                    py: 2
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        maxWidth: "100%",
                    }}
                >
                    {/* LEFT — LOGO */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            minWidth: 220, // keeps layout stable
                        }}
                    >
                        <Tooltip
                            title="Lady Wisdom"
                            arrow
                            followCursor
                        >
                            <Box
                                component="img"
                                src="/Colloquia_Logo.png"
                                alt="Colloquia Logo"
                                onClick={() => history.push("/home")}
                                sx={{
                                    height: 90,
                                    width: "auto",
                                    borderRadius: "10px", // rounded edges
                                    cursor: "pointer",
                                    objectFit: "contain",
                                }}
                            />
                        </Tooltip>
                    </Box>
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    gap={2}
                    flexWrap="wrap"
                >
                    {navItems.map((item) => (
                    <Button
                        key={item.path}
                        variant="outlined"
                        sx={getButtonStyles(item)}
                        onClick={() => history.push(item.path)}
                    >
                        {item.label}
                    </Button>
                    ))}
                </Box>
                <Box sx={{ minWidth: 220 }} />
              </Box>
            </Box>
           
           <Box
               p={2} // padding inside box
               my={2} // vertical margin between posts
               border="1px solid #ccc" // light grey border
               borderRadius="8px" // rounded corners
               sx={{
                   position: "relative",
                   maxWidth: 900, // limit width
                   mx: "auto", // center horizontally
                   my: 2, // vertical spacing between each post
               }}
           >
            {/*<Button
                   onClick={(e) => {
                       e.stopPropagation();
                       joinVideoCall(bill._id)}
                   }
                   variant="outlined"
                   size="small"
                   sx={{
                       position: "absolute",
                       top: 8,
                       right: 8,
                       zIndex: 1
                   }}
               >
                   Join Voice Call
               </Button>*/}


               <Typography
                   fontWeight="bold"
                   sx={{
                       wordBreak: "break-word",
                       pr: "140px",
                       mb: 1
                   }}
               >
                   {calBill?.number}: {calBill?.title}
               </Typography>


        {/*<Typography
                  fontWeight="regular"
                  sx={{
                      wordBreak: "break-word",
                      pr: "140px",
                      mb: 1
                  }}
              >
                  {calBill?.description}
               </Typography>*/}
               <Typography variant="body2" component="div">
                <Box component="span" fontWeight="bold">
                    Summary:
                </Box>

                <Box
                    component="div"
                    sx={{ mt: 0.5 }}
                    //dangerouslySetInnerHTML={{ __html: calBill.description }}
                >
                {calBill?.description}
                </Box>
            </Typography>

        <Typography variant="body2">
            <Box component="span" fontWeight="bold">
            Latest Action:
            </Box>{' '}
            {calBill?.last_action || calBill?.last_action_date ? (
            <>
                {calBill?.last_action_date
                ? new Date(calBill?.last_action_date).toLocaleDateString()
                : '—'}{' '}
                — {calBill?.last_action || 'Action recorded'}
            </>
            ) : (
            'No recent action'
            )}
        </Typography>

        <Link
                href={`/api/bill/pdf/${calBill?.doc_id}`}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
            >
                View Bill
                </Link>


               {/*<Box
                   display="flex"
                   justifyContent="center"
                   sx={{
                       mb: 2,
                       //my: 1
                   }}
               >
                   <Button
                       variant="outlined"
                       size="small"
                       onClick={() => handleOpenDialog(calBill?._id)}
                       sx={{ ml: 2.3 }}
                       //sx={{ mr: 2.3 }}
                   >
                       Vote
                   </Button>
               </Box>*/}
               {/*<Box
                display="flex"
                justifyContent="center"
                sx={{ mb: 2 }}
            >
                {loggedInUser &&
                    calBill?.billVoters?.some(voter =>
                        isSameUser(voter, loggedInUser._id)
                ) ? (
                    <Box
                        sx={{
                            display: "inline-flex",
                            "&:hover .voted-btn": {
                            display: "none",
                            },
                            "&:hover .undo-btn": {
                            display: "inline-flex",
                            },
                        }}
                    >
                    {loggedInUser &&
                    calBill?.noPassPowerVotes?.some(vote =>
                        isSameUser(vote.user, loggedInUser._id)
                ) ? (
                    <Button
                        className="voted-btn"
                        variant="outlined"
                        size="small"
                        disabled
                        sx={{ ml: 2.3 }}
                    >
                        Voted No Pass
                    </Button>
                    ) : loggedInUser && calBill?.passPowerVotes?.some(vote =>
                        isSameUser(vote.user, loggedInUser._id)
                    ) ? (
                    <Button
                        className="voted-btn"
                        variant="outlined"
                        size="small"
                        disabled
                        sx={{ ml: 2.3 }}
                    >
                        Voted Pass
                    </Button>
                    ) : null}
                    <Button
                        className="undo-btn"
                        variant="contained"
                        color="error"
                        size="small"
                        sx={{ display: "none", ml: 2.3 }}
                        onClick={(e) => {
                            e.stopPropagation();
                            setPendingUndoCaseId(calBill?._id);
                            setPendingUndoBill(calBill);
                            setUndoDialogOpen(true);
                        }}
                    >
                        Undo Vote
                    </Button>
                </Box>
                ) : (
                    <Button
                        variant="outlined"
                        size="small"
                        sx={{ ml: 2.3 }}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleOpenDialog(calBill?._id);
                        }}
                    >
                        Power Vote
                    </Button>
                )}
            </Box>*/}
            <Box display="flex" justifyContent="center" sx={{ mb: 2 }}>
                {loggedInUser && calBill?.votedStateBill ? (
                    <Box
                        sx={{
                            display: "inline-flex",
                            "&:hover .voted-btn": { display: "none" },
                            "&:hover .undo-btn":  { display: "inline-flex" },
                        }}
                    >
                        <Button
                            className="voted-btn"
                            variant="outlined"
                            size="small"
                            disabled
                            sx={{ ml: 2.3 }}
                        >
                            {calBill.votedSide === "no pass"
                            ? "Voted No Pass"
                            : "Voted Pass"}
                        </Button>
                        <Button
                            className="undo-btn"
                            variant="contained"
                            color="error"
                            size="small"
                            sx={{ display: "none", ml: 2.3 }}
                            onClick={(e) => {
                                e.stopPropagation();
                                setPendingUndoCaseId(calBill._id);
                                setPendingUndoBill(calBill);
                                setUndoDialogOpen(true);
                            }}
                        >
                            Undo Vote
                        </Button>
                    </Box>
                ) : (
                    <Button
                        variant="outlined"
                        size="small"
                        sx={{ ml: 2.3 }}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleOpenDialog(calBill._id);
                        }}
                    >
                        Power Vote
                    </Button>
                )}
            </Box>


               <Box
                   display="flex"
                   alignItems="center"
                   justifyContent="center"
                   sx={{ mb: 2 }}
                   >
                   <Typography variant="body2">No Pass Votes</Typography>


                   <Box
                       sx={{
                           position: "relative",
                           height: "2px",
                           backgroundColor: "#ccc",
                           width: "300px",
                           mx: 2
                       }}>

                           <Box sx={{
                               position: "absolute",
                               top: "-6px",
                               left: "50%",
                               transform: "translateX(-50%)",
                               width: "2px",
                               height: "14px",
                               backgroundColor: "black"
                           }} />
                      

                       <Box
                           sx={{
                               position: "absolute",
                               top: "-6px",
                               left: `calc(50% + ${offset}%)`,
                               transform: "translateX(-50%)",
                               display: "flex",
                               flexDirection: "column",
                               alignItems: "center"
                           }}
                           >

                           <Box sx={{
                               width: "2px",
                               height: "14px",
                               backgroundColor: tickColor
                           }} />


                           <Typography
                               variant="caption"
                               sx={{ mt: "2px", fontSize: "0.7rem" }}
                           >
                               {(votePercentage * 100).toFixed(0)}%
                           </Typography>
                           </Box>
                       </Box>




                       <Typography variant="body2">Pass Votes</Typography>
               </Box>


               {/*<Link
              href={`/api/bill/pdf/${calBill?.doc_id}`}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
          >
              View Bill
            </Link>*/}

               <Box mt={2} display="flex" alignItems="center" gap={1}>
                   <Button
                       size="small"
                       variant={calBill?.voted ? "contained" : "outlined"}
                       onClick={() => toggleVote(calBill._id)}
                   >
                       ▲ {calBill?.voted ? "Unvote" : "Upvote"}
                   </Button>
                   {/*<Typography variant="body2">{calBill?.upvoteCount} Visibility Upvotes | {calBill?.noPassCount} No Pass Votes | {calBill?.passCount} Pass Votes</Typography>*/}
                   <Typography variant="body2">
                    {calBill?.upvoteCount} Visibility Upvotes |{" "}
                    <Box
                        component="span"
                        sx={{ color: "primary.main",}}
                        //sx={{ cursor: "pointer", color: "primary.main", "&:hover": { textDecoration: "underline" } }}
                        //onClick={(e) => openNoPassVoters(e, calBill)}
                    >
                        {calBill?.noPassCount} No Pass Votes
                    </Box>{" "}
                    |{" "}
                    <Box
                        component="span"
                        sx={{ color: "primary.main",}}
                        //sx={{ cursor: "pointer", color: "primary.main", "&:hover": { textDecoration: "underline" } }}
                        //onClick={(e) => openPassVoters(e, calBill)}
                    >
                        {calBill?.passCount} Pass Votes
                    </Box>
                </Typography>
               </Box>

           </Box>
           
          {/*<Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth>
              <DialogTitle>Cast Your Power Vote</DialogTitle>
              <DialogContent>
                  <Box display="flex" gap={2} mb={2}>
                      <Button
                        variant={voteType === "No Pass" ? "contained" : "outlined"}
                        onClick={() => setVoteType("No Pass")}  
                      >
                        No Pass
                      </Button>
                      <Button
                          variant={voteType === "Pass" ? "contained" : "outlined"}
                          onClick={() => setVoteType("Pass")}
                      >
                          Pass
                      </Button>
                  </Box>
                  <TextField
                      fullWidth
                      multiline
                      rows={3}
                      placeholder="Explain your power vote (required)"
                      value={comment}
                      onChange={(e) => setComment(e.target.value)}
                  />
              </DialogContent>
              <DialogActions>
                  <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                  <Button
                      variant="outlined"
                      onClick={handleSubmitVote}
                      disabled={!comment || !voteType}
                  >
                      Submit Power Vote
                  </Button>
              </DialogActions>
          </Dialog>*/}
          <Dialog 
            open={openDialog} 
            onClose={() => setOpenDialog(false)} 
            fullWidth
            PaperProps={{
                sx: {
                backgroundColor: "#FFFDF8",
                borderRadius: 3,
                },
            }}
            >
               <DialogTitle>Cast Your Power Vote</DialogTitle>
                <DialogContent>
                    <Box display="flex" gap={2} mb={2}>
                        <Button
                            variant={voteType === "NP" ? "contained" : "outlined"}
                            onClick={() => setVoteType("NP")}
                        >
                            No Pass
                        </Button>
                        <Button
                            variant={voteType === "P" ? "contained" : "outlined"}
                            onClick={() => setVoteType("P")}
                        >
                            Pass
                        </Button>
                    </Box>
                    <TextField
                        fullWidth
                        multiline
                        rows={3}
                        placeholder="Explain your power vote (required)"
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                    <Button
                        variant="outlined"
                        onClick={handleSubmitVote}
                        disabled={!comment || !voteType}
                    >
                        Submit Power Vote
                    </Button>
                </DialogActions>
           </Dialog>

           <Dialog
                open={undoDialogOpen}
                onClose={() => setUndoDialogOpen(false)}
                PaperProps={{
                    sx: {
                        backgroundColor: "#FFFDF8",
                        borderRadius: 3,
                        px: 2,
                        py: 1.5,
                    },
                }}
                >
                <DialogTitle sx={{ fontWeight: 600 }}>
                    Undo your vote?
                </DialogTitle>

                <DialogContent>
                    <DialogContentText sx={{ color: "text.primary" }}>
                        This will remove your vote and the vote rationale comment associated with it.
                        This action cannot be undone.
                    </DialogContentText>
                </DialogContent>

                <DialogActions sx={{ pb: 2, px: 3 }}>
                    <Button
                        onClick={() => setUndoDialogOpen(false)}
                        variant="outlined"
                        sx={{
                            borderColor: "#d0cfc8",
                            color: "text.primary",
                        }}
                    >
                        Cancel
                    </Button>

                    <Button
                        onClick={() => {
                            handleUndoVote(pendingUndoCaseId, pendingUndoBill);
                            setUndoDialogOpen(false);
                            setPendingUndoCaseId(null);
                            setPendingUndoBill(null);
                        }}
                        variant="contained"
                        color="error"
                        sx={{
                            boxShadow: "none",
                        }}
                    >
                        Yes, Undo Vote
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openVotersDialog}
                onClose={() => setOpenVotersDialog(false)}
                fullWidth
                maxWidth="xs"
                PaperProps={{
                    sx: {
                        backgroundColor: "#FFFDF8",
                        borderRadius: 3,
                    },
                }}
            >
                <DialogTitle sx={{ fontWeight: 600 }}>
                    {dialogTitle}
                </DialogTitle>

                <DialogContent dividers>
                    {activeVoters.length === 0 ? (
                    <Typography variant="body2" color="text.secondary">
                        No votes
                    </Typography>
                    ) : (
                    <List disablePadding>
                        {activeVoters.map(vote => (
                        <ListItem 
                            key={vote.user._id} 
                            button
                            onClick={(e) => visitProfile(e, vote.user._id)}
                            sx={{
                                px: 0,
                                borderRadius: 2,
                                cursor: 'pointer',
                                transition: 'background-color 0.2s',
                                '&:hover': {
                                    backgroundColor: '#FFF2CC', // subtle highlight
                                },
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    width: '100%',
                                }}
                            >
                                {/* Left side: Avatar + user info */}
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <ListItemAvatar>
                                    <Avatar src={vote.user.profileImageUrl}>
                                        {vote.user.username?.[0]}
                                    </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={`${vote.user.first_name} ${vote.user.last_name}`}
                                        secondary={`@${vote.user.username}`}
                                    />
                                </Box>
                                <Typography variant="body2" color="text.secondary">
                                    Voting Power: {vote.user.tier}
                                </Typography>
                            </Box>
                        </ListItem>
                        ))}
                    </List>
                    )}
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setOpenVotersDialog(false)}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

           <Box
               p={2} // padding inside box
               my={2} // vertical margin between posts
               border="1px solid #ccc" // light grey border
               borderRadius="8px" // rounded corners
               sx={{
                   position: "relative",
                   maxWidth: 900, // limit width
                   mx: "auto", // center horizontally
                   my: 2, // vertical spacing between each post
               }}
           >
           <TextField
               fullWidth
               multiline
               rows={2}
               placeholder="Engage in intellectual discourse..."
               value={newComment}
               onChange={e => setNewComment(e.target.value)}
           />
           <Button variant="outlined" sx={{ mt: 1 }} onClick={handleSubmitComment}>
               Submit Comment
           </Button>
           </Box>




           {comments.length === 0 ? (
               <Typography></Typography>
           ) : (
               comments.map((comment, i) => {
                const isLast = i === comments.length - 1;
                return (
               <Box
                   p={2} // padding inside box
                   ref={isLast ? lastCommentRef : null}
                   onClick={() => history.push(`/calBill/${id}/comments/${comment._id}`)}
                   my={2} // vertical margin between posts
                   border="1px solid #ccc" // light grey border
                   borderRadius="8px" // rounded corners
                   sx={{
                       position: "relative",
                       maxWidth: 900, // limit width
                       mx: "auto", // center horizontally
                       my: 2, // vertical spacing between each post
                       cursor: "pointer",
                       "&:hover": {
                           backgroundColor: "#f9f9f9"
                       }
                   }}
           >




                   <Box display="flex" alignItems="flex-start" gap={1}>
                               <Avatar
                                   src={comment.author?.profileImageUrl || '/default-avatar.jpg'}
                                   alt={`${comment.author?.first_name || ''} ${comment.author?.last_name || ''}`}
                                   onClick={(e) => visitProfile(e, comment.author?._id)}
                                    sx={{ 
                                    width: 62, 
                                    height: 62,
                                    cursor: "pointer",
                                    "&:hover": {
                                        backgroundColor: "#d9e4f0",
                                    }, 
                                    }}
                               />
                               <Box>
                                   <Typography variant="subtitle1" fontWeight="bold"
                                   onClick={(e) => visitProfile(e, comment.author?._id)}
                                    sx={{
                                        cursor: "pointer",
                                        display: "inline-block",
                                        "&:hover": {
                                        textDecoration: "underline",
                                        textDecorationColor: "currentColor", 
                                        textUnderlineOffset: "3px",
                                        },
                                    }}
                                   >
                                   {comment.author?.first_name && comment.author?.last_name
                                       ? `${comment.author.first_name} ${comment.author.last_name}`
                                       : 'Unknown Name'}
                                   </Typography>
                                   <Typography variant="body2" color="text.secondary"
                                   onClick={(e) => visitProfile(e, comment.author?._id)}
                                    sx={{
                                        cursor: "pointer",
                                        display: "block",
                                        "&:hover": {
                                        textDecoration: "underline",
                                        textDecorationColor: "#currentColor",
                                        textUnderlineOffset: "3px",
                                        },
                                    }}
                                   >
                                   @{comment.author?.username || 'unknown'}
                                   </Typography>


                                   <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
                                       {comment.text}
                                   </Typography>


                                   <Typography
                                        variant="caption"
                                        color="text.secondary"
                                        sx={{ display: "block", mt: 0.5 }}
                                    >
                                        {`${new Date(comment.created_at).toLocaleString()}, ${
                                            comment.replyCount
                                        } ${comment.replyCount === 1 ? 'reply' : 'replies'}`}
                                    </Typography>


                               </Box>
                           </Box>




                           {/*<Box mt={2} display="flex" alignItems="center" gap={1}>
                               <Button
                                   size="small"
                                   variant={comment.voted ? "contained" : "outlined"}
                                   onClick={(e) => {
                                       e.stopPropagation();
                                       toggleCommentVote(comment._id)}
                                   }
                               >
                                   ▲ {comment.voted ? "Unvote" : "Upvote"}
                               </Button>
                               <Typography variant="body2">{comment.upvotes} upvotes</Typography>
                           </Box>*/}
                            <Box mt={2} display="flex" alignItems="center" gap={1}>
                                {comment.voted ? (
                                    <Box
                                    sx={{
                                        position: "relative",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        "&:hover .voted-btn": {
                                            opacity: 0,
                                        },
                                        "&:hover .undo-btn": {
                                            opacity: 1,
                                            pointerEvents: "auto",
                                        },
                                    }}
                                >
                                        <Button
                                            size="small"
                                            className="voted-btn"
                                            variant="contained"
                                            color="success"
                                            disabled
                                            sx={{
                                            transition: "opacity 0.2s ease",
                                            }}
                                        >
                                        Power Voted
                                    </Button>
                                    <Button
                                            size="small"
                                            className="undo-btn"
                                            variant="contained"
                                            color="error"
                                            sx={{
                                            inset: 0,
                                            position: "absolute",
                                            transition: "opacity 0.2s ease",
                                            opacity: 0,
                                            pointerEvents: "none",
                                        }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            toggleCommentVote(comment._id)
                                        }}
                                    >
                                            Undo
                                    </Button>
                                </Box>
                                ) : (
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        onClick={(e) => {
                                        e.stopPropagation();
                                        toggleCommentVote(comment._id)}
                                    }
                                    >
                                        ▲ Power Vote
                                    </Button>
                                )}
                                <Typography variant="body2">{comment.upvotes} Power Votes</Typography>
                        </Box>




               </Box>
               )})
           )}
           <Dialog open={replyOpen} onClose={handleReplyClose}>
           <DialogTitle>Reply to Comment</DialogTitle>
           <DialogContent>
               <TextField
               autoFocus
               fullWidth
               multiline
               minRows={3}
               value={replyText}
               onChange={(e) => setReplyText(e.target.value)}
               placeholder="Write your reply..."
               />
           </DialogContent>
           <DialogActions>
               <Button onClick={handleReplyClose}>Cancel</Button>
               <Button onClick={handleReplySubmit} variant="contained">
               Post Reply
               </Button>
           </DialogActions>
           </Dialog>

           </div>
   );



}


export default CaliforniaBillCommentsPage;
